"use client";

import { useCookies } from "@/hooks/useCookies";

export default function CookieTracker() {
  useCookies();

  return null;
}
